import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ShopifyMigrationService } from './shopify-migration.service';

@Injectable({
  providedIn: 'root'
})
export class ShopifyRedirectGuardService implements CanActivateChild {
  constructor(
    private shopifyMigrationService: ShopifyMigrationService
  ) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
    const path = childRoute.routeConfig?.path;

    return this.shopifyMigrationService.getShopifyLinks().pipe(
      map(links => links.find(link => link.path === path)),
      map(link => {
        if (link && link.forceRedirect) {
          window.location.href = link.shopifyLink;
          return false;
        }

        return true;
      }),
      catchError(() => of(true))
    );
  }
}
